/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-non-null-assertion

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogInput } from '@gh/core-ui';
import { createDialogRoute } from '@gh/common-shared';
import {
  getGraphicalTakeOffTopType, GraphicalTakeOffChangeOption,
  GraphicalTakeOffTop,
  GraphicalTakeOffTopView,
  GTO_MEASUREMENT_TYPE_COUNT, isGrpahicalTakeOffTopViewMeasurementExists,
} from '../../resources';

export interface GraphicalTakeOffChangeDialogConfig {
  topView: GraphicalTakeOffTopView;
  tops: GraphicalTakeOffTop[];
}

/**
 * Change TOP component
 */
@Component({
  selector: 'gh-graphical-take-off-change',
  template: require('./graphical-take-off-change.component.html'),
  styles: [require('./graphical-take-off-change.component.scss')],
})
export class GraphicalTakeOffChangeComponent implements OnInit, DialogInput<GraphicalTakeOffChangeDialogConfig> {
  input: GraphicalTakeOffChangeDialogConfig;

  topCode: string;

  /**
   * Change TOP
   *
   * @type {GraphicalTakeOffTop}
   */
  changeTop: GraphicalTakeOffTop;

  /**
   * Change option
   *
   * @type {GraphicalTakeOffChangeOption}
   */
  option: GraphicalTakeOffChangeOption = GraphicalTakeOffChangeOption.CURRENT_VIEW;

  /**
   * Is change current measurement option disabled?
   *
   * @type {boolean}
   */
  optionCurrentDisabled: boolean = true;

  /**
   * Constructor
   *
   * @param {any} data - Dialog data
   * @param {MatDialogRef<GraphicalTakeOffChangeComponent>} dialogRef - Dialog ref
   * @returns {void}
   */
  constructor(
    private dialogRef: MatDialogRef<GraphicalTakeOffChangeComponent>,
  ) {
  }

  ngOnInit(): void {
    this.setOptionCurrentDisabled();
    this.topCode = this.input.topView.takeOffParam.code;
  }

  setOptionCurrentDisabled(): void {
    const measurementsExists = isGrpahicalTakeOffTopViewMeasurementExists(this.input.topView);
    const type = getGraphicalTakeOffTopType(this.input.topView);

    this.option = GTO_MEASUREMENT_TYPE_COUNT !== type && measurementsExists
      ? GraphicalTakeOffChangeOption.CURRENT_SELECTION
      : GraphicalTakeOffChangeOption.CURRENT_VIEW;
    this.optionCurrentDisabled = GTO_MEASUREMENT_TYPE_COUNT === type || !measurementsExists;
  }

  /**
   * Close dialog
   *
   * @returns {void}
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Apply change
   *
   * @returns {void}
   */
  apply(): void {
    this.dialogRef.close({
      top: this.changeTop,
      option: this.option,
    });
  }
}

export const graphicalTakeOffChangeDialogRoute = createDialogRoute({
  component: GraphicalTakeOffChangeComponent,
  config: {
    'width': '360px',
  },
});
